import React, { FC } from 'react';

import { Badge, BadgeProps, useMantineTheme } from '@mantine/core';

const VoltageTypeBadge: FC<
    {
        voltageType: 'AC' | 'DC';
        enabled?: boolean;
        activated?: boolean;
        onClick?: () => void;
    } & BadgeProps
> = ({ voltageType, enabled = false, activated = false, onClick, ...props }) => {
    const theme = useMantineTheme();

    const backgroundColor = [
        {
            voltageType: 'AC',
            enabled: false,
            activated: false,
            color: '#ffffff',
        },
        {
            voltageType: 'AC',
            enabled: false,
            activated: true,
            color: theme.colors.gray['5'],
        },
        {
            voltageType: 'AC',
            enabled: true,
            activated: false,
            color: '#ffffff',
        },
        {
            voltageType: 'AC',
            enabled: true,
            activated: true,
            color: theme.colors.orange['9'],
        },
        {
            voltageType: 'DC',
            enabled: false,
            activated: false,
            color: '#ffffff',
        },
        {
            voltageType: 'DC',
            enabled: false,
            activated: true,
            color: theme.colors.gray['5'],
        },
        {
            voltageType: 'DC',
            enabled: true,
            activated: false,
            color: '#ffffff',
        },
        {
            voltageType: 'DC',
            enabled: true,
            activated: true,
            color: theme.colors.blue['9'],
        },
    ].find(
        (item) => item.voltageType === voltageType && item.enabled === enabled && item.activated === activated,
    )?.color;

    const color = [
        { enabled: false, activated: false, color: theme.colors.gray['4'] },
        { enabled: false, activated: true, color: '#ffffff' },
        { enabled: true, activated: false, color: theme.colors.gray['9'] },
        { enabled: true, activated: true, color: '#ffffff' },
    ].find((item) => item.enabled === enabled && item.activated === activated)?.color;

    return (
        <Badge
            size="xs"
            style={{
                backgroundColor,
                color,

                paddingLeft: 4,
                paddingRight: 4,
                borderRadius: theme.radius.xs,

                cursor: onClick ? 'pointer' : 'default',

                flexShrink: 0,
            }}
            onClick={onClick}
            {...props}
        >
            {voltageType}
        </Badge>
    );
};

export { VoltageTypeBadge };
